import Icon from '../components/Icon.vue'

Icon.register({
  'meh-blank': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM168 240C150.3 240 136 225.7 136 208S150.3 176 168 176 200 190.3 200 208 185.7 240 168 240zM328 240C310.3 240 296 225.7 296 208S310.3 176 328 176 360 190.3 360 208 345.7 240 328 240z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/meh-blank.js
// module id = zLiH
// module chunks = 144